import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { CheckBox, SelectBox, TextArea, TextBox, Validator } from 'devextreme-react';

import {
  useChangeContractorLegalMutation,
  useCreateContractorLegalMutation,
  useLazyGetContractorLegalDetailQuery,
  useLazyGetContractorLegalSearchBankDetailsQuery,
  useLazyGetContractorLegalSearchQuery,
} from 'bus/contractorLegal/services/services';
import { ContractorLegalItem } from 'bus/contractorLegal/types';
import { useGetContractorObjectLocationsQuery } from 'bus/contractorObject/services';

import { typeContractor } from 'types/books';

import { initialStateForm } from '../../utils';

type DetailModalRoleProps = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DetailModalRole: FC<DetailModalRoleProps> = (props) => {
  const [getContractorLegalDetail] = useLazyGetContractorLegalDetailQuery();
  const [getContractorLegalSearchBankDetails] = useLazyGetContractorLegalSearchBankDetailsQuery();
  const [getContractorLegalSearch] = useLazyGetContractorLegalSearchQuery();
  const [changeContractorLegal] = useChangeContractorLegalMutation();
  const [createContractorLegal] = useCreateContractorLegalMutation();
  const { data: contractorObjectLocations } = useGetContractorObjectLocationsQuery();

  let createCatalogGroupRef = useRef<Form>(null);
  let createCatalogGroupRefValid = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<ContractorLegalItem>({ ...initialStateForm });

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogGroupRefValid.current?.instance.validate().isValid) {
      if (props.id) {
        await changeContractorLegal(form);
      } else {
        await createContractorLegal({ ...form });
      }
      props.refresh();
      props.changeVisible(false);
    }
  };

  const onShown = async () => {
    createCatalogGroupRef.current?.instance.resetValues();
    createCatalogGroupRefValid.current?.instance.reset();
    if (props.id) {
      await getContractorLegalDetail({ id: props.id }).unwrap().then(setForm);
    }
  };

  const onHidden = () => {
    setForm({ ...initialStateForm });
    createCatalogGroupRefValid.current?.instance.reset();
  };

  const searchInn = async () => {
    const result = await getContractorLegalSearch({ inn: form.inn }).unwrap();
    setForm((prev) => ({ ...prev, ...result }));
  };

  const searchBankDetail = async () => {
    const result = await getContractorLegalSearchBankDetails({ bik: form.bik }).unwrap();
    setForm((prev) => ({ ...prev, ...result }));
  };

  const searchInnButton = useMemo(
    () => ({
      name: 'search',
      options: {
        onClick: () => searchInn(),
        icon: 'search',
        type: 'default',
        stylingMode: 'text',
        disabled: !form.inn,
      },
    }),
    [form.inn, searchInn],
  );

  const searchBikButton = useMemo(
    () => ({
      name: 'searchBik',
      options: {
        onClick: () => searchBankDetail(),
        icon: 'search',
        type: 'default',
        stylingMode: 'text',
        disabled: form.bik,
      },
    }),
    [form.bik, searchBankDetail],
  );

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Юр. лицо"
        width={1000}
        onShowing={() => onShown()}
        onHidden={() => onHidden()}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit} action="add-edit-legal">
              <ValidationGroup ref={createCatalogGroupRefValid}>
                <Form formData={form} ref={createCatalogGroupRef}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppGroup col={8} title="Основная информация">
                      <AppRow className="mt-2">
                        <AppGroup col={6}>
                          <AppFiledBox label="ИНН" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="Заполните поле ИНН"
                              mode="text"
                              value={form.inn}
                              onValueChange={(e) => {
                                setForm((prev) => ({ ...prev, inn: e }));
                              }}
                              //@ts-ignore
                              buttons={[searchInnButton]}
                            >
                              <Validator>
                                <RequiredRule message="Заполните поле ИНН" />
                              </Validator>
                            </TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={6}>
                          <AppFiledBox label="Тип" labelTop>
                            <SelectBox
                              stylingMode="underlined"
                              placeholder="Выберите Тип"
                              mode="text"
                              value={form.contractorType}
                              onValueChange={(e) => setForm((prev) => ({ ...prev, contractorType: e }))}
                              displayExpr="name"
                              valueExpr="id"
                              dataSource={typeContractor}
                            >
                              <Validator>
                                <RequiredRule message="Заполните поле Тип" />
                              </Validator>
                            </SelectBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={12}>
                          <AppFiledBox label="Полное наименование" labelTop requere>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="Заполните поле Полное наименование"
                              mode="text"
                              value={form.fullName}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, fullName: e.event.currentTarget.value }));
                              }}
                            >
                              <Validator>
                                <RequiredRule message="Заполните поле Полное наименование" />
                              </Validator>
                            </TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={12}>
                          <AppFiledBox label="Краткое наименование" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="Заполните поле Краткое наименование"
                              mode="text"
                              value={form.name}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, name: e.event.currentTarget.value }));
                              }}
                            >
                              <Validator>
                                <RequiredRule message="Заполните поле Краткое наименование" />
                              </Validator>
                            </TextBox>
                          </AppFiledBox>
                        </AppGroup>

                        <AppGroup col={4}>
                          <AppFiledBox label="Фамилия" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder=""
                              mode="text"
                              value={form.directorSurname}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, directorSurname: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={4}>
                          <AppFiledBox label="Имя" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder=""
                              mode="text"
                              value={form.directorName}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, directorName: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={4}>
                          <AppFiledBox label="Отчество" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder=""
                              mode="text"
                              value={form.directorMiddleName}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, directorMiddleName: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>

                        <AppGroup col={12}>
                          <AppFiledBox label="Адрес" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="адрес"
                              mode="text"
                              value={form.address}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, address: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={6}>
                          <AppFiledBox label="ОГРН" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="ОГРН"
                              mode="text"
                              value={form.ogrn}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, ogrn: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={6}>
                          <AppFiledBox label="КПП" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="КПП"
                              mode="text"
                              value={form.kpp}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, kpp: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={6}>
                          <AppFiledBox label="Телефон" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="Телефон"
                              mode="text"
                              value={form.phone}
                              onValueChange={(e: any) => {
                                setForm((prev) => ({ ...prev, phone: e }));
                              }}
                              mask="+7 (000) 000-00-00"
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={6}>
                          <AppFiledBox label="Email" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="Email"
                              mode="email"
                              value={form.email}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, email: e.event.currentTarget.value }));
                              }}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={12}>
                          <AppFiledBox label="Комментарий" labelTop>
                            <TextArea
                              stylingMode="underlined"
                              placeholder="Комментарий"
                              value={form.comment}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                              }}
                            />
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={6}>
                          <AppFiledBox label="" labelTop>
                            <CheckBox
                              value={form.isOwner}
                              text="Собственная организация"
                              onValueChanged={(e) => setForm((prev) => ({ ...prev, isOwner: e.value }))}
                            />
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={6}>
                          <AppFiledBox label="" labelTop>
                            <CheckBox
                              value={form.isProvider}
                              text="Поставщик"
                              onValueChanged={(e) => setForm((prev) => ({ ...prev, isProvider: e.value }))}
                            />
                          </AppFiledBox>
                        </AppGroup>
                      </AppRow>
                    </AppGroup>
                    <AppGroup col={4} title="Реквизиты">
                      <AppRow className="mt-2">
                        <AppGroup col={12}>
                          <AppFiledBox label="БИК" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder=""
                              mode="text"
                              value={form.bik}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, bik: e.event.currentTarget.value }));
                              }}
                              //@ts-ignore
                              buttons={[searchBikButton]}
                              maxLength={9}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={12}>
                          <AppFiledBox label="Банк" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder=""
                              mode="text"
                              value={form.bankName}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, bankName: e.event.currentTarget.value }));
                              }}
                              maxLength={300}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={12}>
                          <AppFiledBox label="Адрес банка" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder=""
                              mode="text"
                              value={form.bankAddress}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, bankAddress: e.event.currentTarget.value }));
                              }}
                              maxLength={300}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={12}>
                          <AppFiledBox label="Расчетный счет" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder=""
                              mode="text"
                              value={form.rs}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, rs: e.event.currentTarget.value }));
                              }}
                              maxLength={20}
                            ></TextBox>
                          </AppFiledBox>
                        </AppGroup>
                        <AppGroup col={12}>
                          <AppFiledBox label="Кор. счет" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder=""
                              mode="text"
                              value={form.ks}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, ks: e.event.currentTarget.value }));
                              }}
                              maxLength={20}
                            ></TextBox>
                          </AppFiledBox>
                          <AppFiledBox label="Местность" labelTop>
                            <SelectBox
                              stylingMode="underlined"
                              placeholder="Выберите местность"
                              mode="text"
                              value={form.locationType}
                              onValueChange={(e) => {
                                setForm((prev) => ({ ...prev, locationType: e }));
                              }}
                              displayExpr="name"
                              valueExpr="id"
                              dataSource={contractorObjectLocations}
                            >
                              <Validator>
                                <RequiredRule message="Заполните поле местность" />
                              </Validator>
                            </SelectBox>
                          </AppFiledBox>
                        </AppGroup>
                      </AppRow>
                    </AppGroup>
                  </Item>
                </Form>

                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => props.changeVisible(false)}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
